import './styles.scss'
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'
import uniqid from 'uniqid'

import { apiConversation } from 'api'
import { setCurrentDataOutbound } from 'redux/outbound/actions'
import { getStaticImage } from 'utils/statics'

const UserCardOutbound = ({ draft }) => {
  const { brands, delegations } = useSelector(store => store)
  const dispatch = useDispatch()
  const [draftData, setDraftData] = useState({})
  const [outboundData, setOutboundData] = useState({})
  const { _id, provider, delegation, assignedToMe, to, updatedAt } = draft

  useEffect(() => {
    apiConversation.conversations.getDraftById({ draftId: _id })
      .then(({ data }) => setDraftData(data))
  }, [])

  useEffect(() => {
    if (!Object.keys(draftData).length) return

    getOutboundData({
      channel: draftData.provider,
      brand: draftData.brand,
      delegation: draftData.delegation,
      deliveryChannel: {
        channel: draftData.channelId,
        assignToMe: draftData.assignedToMe
      },
      to: draftData.to,
      cc: draftData.cc,
      cco: draftData.cco,
      subject: draftData.subject,
      message: draftData.message
    })
      .then(data => setOutboundData(data))
  }, [draftData])

  const getOutboundData = async ({ channel, brand, delegation, deliveryChannel, to, cc, cco, subject, message }) => {
    const visibleFields = ['to']

    let deliveryChannelData = ''
    if (deliveryChannel?.channel) {
      const { data } = await apiConversation.conversations.getChannelsOPTOUT({ type: channel })

      const channelData = data.find(channel => channel.id === deliveryChannel.channel)
      if (channelData) {
        deliveryChannelData = {
          value: deliveryChannel.channel,
          label: channelData.value
        }
      }
    }

    const toChipsValues = []
    if (to?.length) {
      to.forEach(contact => {
        toChipsValues.push({
          id: uniqid(),
          value: contact.identifier,
          isValid: true
        })
      })
    }

    const ccChipsValues = []
    if (cc?.length) {
      cc.forEach(contact => {
        ccChipsValues.push({
          id: uniqid(),
          value: contact.identifier,
          isValid: true
        })
        visibleFields.push('cc')
      })
    }

    const ccoChipsValues = []
    if (cco?.length) {
      cco.forEach(contact => {
        ccoChipsValues.push({
          id: uniqid(),
          value: contact.identifier,
          isValid: true
        })
        visibleFields.push('cco')
      })
    }

    return {
      channel,
      brand: brand ? [{ value: brand, label: brands[brand].name }] : [],
      delegation: delegation ? [{ value: delegation, label: delegations[delegation].name }] : [],
      deliveryChannel: {
        channel: deliveryChannelData,
        assignToMe: deliveryChannel?.assignToMe ? deliveryChannel.assignToMe : false,
        isBlockedAssignToMe: deliveryChannel?.isBlockedAssignToMe ? deliveryChannel.isBlockedAssignToMe : false
      },
      deliveryChannelOptions: null,
      to: {
        chips: toChipsValues,
        input: ''
      },
      cc: {
        chips: ccChipsValues,
        input: ''
      },
      cco: {
        chips: ccoChipsValues,
        input: ''
      },
      template: [],
      subject,
      message: message ? message : {},
      visibleFields
    }
  }

  const handleEditDraft = async () => {
    if (!Object.keys(outboundData).length) return

    dispatch(setCurrentDataOutbound({
      draftId: draftData._id,
      outboundCurrentData: outboundData
    }))
  }

  return (
    <div className='user-card-outbound' onClick={handleEditDraft}>
      <figure className='user-card-outbound__avatar'>
        <img src={getStaticImage('/icons/orange-brand/icon-avatar.svg')} alt='Avatar' />
      </figure>
      <div className='user-card-outbound__content'>
        <strong className='user-card-outbound__to text-ellipsis'>
          {to[0].identifier}
        </strong>
        <span className='user-card-outbound__delegation text-ellipsis'>
          {delegations[delegation].name}
        </span>
        <span className='user-card-outbound__date text-ellipsis'>
          {moment(updatedAt).format('DD-MM-YYYY hh:mm:ss')}
        </span>
      </div>
      <div className='user-card-outbound__icons'>
        <div className='user-card-outbound__icons-top'>
          <figure className='user-card-outbound__icon-assignment'>
            <img src={getStaticImage(`/icons/orange-brand/icon-${assignedToMe ? 'unassign' : 'assign'}-primary.svg`)} alt='Assignment' />
          </figure>
        </div>
        <div className='user-card-outbound__icons-bottom'>
          <figure className='user-card-outbound__icon-channel'>
            <img src={getStaticImage(`/channels/orange-brand/${provider}-icon.svg`)} alt='Channel' />
          </figure>
        </div>
      </div>
    </div>
  )
}

export default UserCardOutbound
